let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8JToC")).then(() => parcelRequire('faH00'));